import styled from "@emotion/styled";

export const SectionAuth = styled.section`
  display: flex;
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
`;
export const AuthBox = styled.div`
  padding: 40px;
  width: 380px;
  box-shadow: var(--g-shadow);
  background: var(--g-surface);
  border: 1px solid var(--g-border);
  border-radius: 22px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AuthTitle = styled.h2`
  font-size: 24px;
  font-weight: 800;
  line-height: 1.2;
  letter-spacing: -0.04em;
  color: var(--g-text);
  margin: 0px 0px 24px 0px;
`;